window.addEventListener("DOMContentLoaded", (event) => {
  let state = {
    searchFormIsOpen: false,
  };

  const elements = {
    searchButton: document.querySelector("[data-search-button]"),
    searchForm: document.querySelector("[data-search-form]"),
    searchFormInput: document.querySelector("#q"),
    accordion: document.querySelectorAll("[data-accordion-trigger]"),
    subNavBlock: document.querySelectorAll("[data-accordion-block]"),
    icons: document.querySelectorAll(".accordion--icon"),
    wrapper: document.querySelector("#wrapper"),
    beforeAfterResize: document.querySelector("[data-before-after-resize]"),
    beforeAfterHandle: document.querySelector("[data-before-after-handle]"),
    beforeAfterWrapper: document.querySelector("[data-before-after-wrapper]"),
    beforeAfterContainer: document.querySelector(".before-after"),
    colorExpandSelector: document.querySelector("[data-color-expand]"),
    colorSwatchMore: document.querySelectorAll(".color-options--show-more"),
    colorSwatchLess: document.querySelectorAll(".color-options--show-less"),
    colorSwatchVariantSelector: document.querySelectorAll("[data-variant-selector]"),
    readmoreButtons: document.querySelectorAll(".expand-item-link"),
    isProductPage: document.querySelector(".product-page") !== null,
    mobileSearchIcon: document.querySelector("#mobileSearchIcon")
  };

  elements.searchFormInput.addEventListener("focus", function(event) {
    event.stopImmediatePropagation()
  })

  elements.searchButton.addEventListener("click", function (event) {
    if (!elements.searchForm.classList.contains("active")) {
      elements.searchForm.classList.add("active");
      elements.searchButton.classList.add("v-hide");
      state.searchFormIsOpen = true;
      window.setTimeout(() => elements.searchFormInput.focus(), 100);
      event.stopPropagation();
    }
  });

  elements.wrapper.addEventListener("click", function (event) {
    if (state.searchFormIsOpen && event.target != elements.searchFormInput) {
      elements.searchForm.classList.remove("active");
      elements.searchButton.classList.remove("v-hide");
    }
  });

  elements.accordion.forEach((accordion) => {
    accordion.addEventListener("click", function (event) {
      let hasOpenAccordion = false;
      elements.accordion.forEach((selectedAccordion) => {
        selectedAccordion === event.target
          ? selectedAccordion.classList.toggle("active")
          : selectedAccordion.classList.remove("active");
        if (selectedAccordion.classList.contains("active")) {
          hasOpenAccordion = true;
        }
      });
      elements.icons.forEach((icon) =>
        !hasOpenAccordion ? icon.classList.remove("active") : icon.classList.add("active")
      );
    });
  });

  // Language + Country Select
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector("button"),
        panel: this.querySelector("ul"),
      };
      this.elements.button.addEventListener("click", this.openSelector.bind(this));
      this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
      this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

      this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
      );
    }

    hidePanel() {
      this.elements.button.setAttribute("aria-expanded", "false");
      this.elements.panel.setAttribute("hidden", true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      if (!this.event.classList.contains("external-link")) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute("hidden");
      this.elements.button.setAttribute(
        "aria-expanded",
        (this.elements.button.getAttribute("aria-expanded") === "false").toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define("localization-form", LocalizationForm);

  const COLOR_DOT_LIMIT = 5;

  // Schwellwerte aus dem Liquid lesen (data-color-dot-limit / data-color-dot-limit-small
  // am .swatch), damit der Farbfamilien-Filter dieselben Werte nutzt wie das gerenderte
  // Color-Dots-Markup. Auf sehr schmalen Viewports (unter 380px) gilt der kleinere
  // Schwellwert - analog zur CSS-Regel, die dort eingeklappt einen Dot weniger zeigt.
  // Sonst weicht der Family-Modus vom Alle-Modus ab (More/Less-Position + Anzahl).
  function getColorDotLimit(swatchEl) {
    const ds = swatchEl && swatchEl.dataset ? swatchEl.dataset : {};
    const useSmall = window.matchMedia('(max-width: 379px)').matches && ds.colorDotLimitSmall;
    const v = parseInt(useSmall ? ds.colorDotLimitSmall : ds.colorDotLimit, 10);
    return Number.isFinite(v) && v > 0 ? v : COLOR_DOT_LIMIT;
  }

  function getFamilyVisibleDots(swatchEl, family) {
    const dots = swatchEl.querySelectorAll('.swatch__color-dots-region .swatch-element.color');
    if (family === 'all') {
      return Array.from(dots);
    }
    return Array.from(dots).filter((dot) => {
      const families = (dot.dataset.colorFamily || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      return families.includes(family);
    });
  }

  function positionToggleButtons(visible, showMore, showLess, limit) {
    const lim = limit || COLOR_DOT_LIMIT;
    if (visible.length < lim) return;
    const moreAnchor = visible[lim - 2];
    if (showMore && moreAnchor) moreAnchor.insertAdjacentElement('afterend', showMore);
    const lessAnchor = visible[visible.length - 1];
    if (showLess && lessAnchor) lessAnchor.insertAdjacentElement('afterend', showLess);
  }

  function syncColorDotsCollapse(swatchEl, family, expanded) {
    const limit = getColorDotLimit(swatchEl);
    const dots = swatchEl.querySelectorAll('.swatch__color-dots-region .swatch-element.color');
    const showMore = swatchEl.querySelector('.color-options--show-more');
    const showLess = swatchEl.querySelector('.color-options--show-less');

    if (family === 'all') {
      // Alle-Modus: positionsbasierte Responsive-Regeln wieder aktiv, swatch--expanded
      // spiegelt den Expand-Zustand (steuert die 5/6-Dot-Regel unter 380px).
      swatchEl.classList.remove('swatch--family-active');
      swatchEl.classList.toggle('swatch--expanded', !!expanded);
      dots.forEach((dot) => {
        dot.style.display = '';
        dot.classList.toggle('hidden', dot.dataset.expand === 'true' && !expanded);
      });
      showMore?.classList.toggle('hidden', !!expanded);
      showLess?.classList.toggle('hidden', !expanded);
      positionToggleButtons(Array.from(dots), showMore, showLess, limit);
      return;
    }

    // Family-Modus steuert die Sichtbarkeit ueber die .hidden-Klasse. Die
    // positionsbasierte CSS-Regel unter 380px wuerde hier einen gefilterten
    // Dot faelschlich ausblenden -> via swatch--family-active komplett deaktivieren
    // und den vererbten swatch--expanded-Zustand entfernen.
    swatchEl.classList.remove('swatch--expanded');
    swatchEl.classList.add('swatch--family-active');

    const visible = getFamilyVisibleDots(swatchEl, family);

    // .hidden ist die massgebliche Sichtbarkeits-Klasse (CSS-Regel ohne !important).
    // Inline display deshalb zuruecksetzen und die Sichtbarkeit ausschliesslich
    // ueber .hidden steuern - sonst bleibt ein gefilterter Dot, der aus dem Liquid
    // bereits die .hidden-Klasse traegt (globaler Index >= color_dot_limit), unsichtbar.
    dots.forEach((dot) => {
      dot.style.display = '';
      if (!visible.includes(dot)) {
        dot.classList.add('hidden');
      }
    });

    if (visible.length < limit) {
      visible.forEach((dot) => dot.classList.remove('hidden'));
      showMore?.classList.add('hidden');
      showLess?.classList.add('hidden');
    } else {
      visible.forEach((dot, i) => {
        dot.classList.toggle('hidden', !expanded && i >= limit - 1);
      });
      showMore?.classList.toggle('hidden', !!expanded);
      showLess?.classList.toggle('hidden', !expanded);
    }
    positionToggleButtons(visible, showMore, showLess, limit);
  }

  if (typeof elements.colorExpandSelector !== "undefined" &&
      elements.colorExpandSelector !== null &&
      elements.isProductPage
  ) {

    elements.colorSwatchMore.forEach((element) => {
      const id = element.dataset.id;
      const dots = document.querySelectorAll(`[data-product-id="${id}"] [data-dot-selector]`);
      const swatchContainer = element.closest(".swatch");
      element.addEventListener("click", function () {
        const swatchEl = element.closest('.swatch');
        const activeBtn = swatchEl && swatchEl.querySelector('.color-families__item[aria-pressed="true"]');
        const family = activeBtn ? ((activeBtn.dataset.colorFamily || 'all').trim() || 'all') : 'all';
        if (swatchEl && swatchEl.querySelector('.color-families') && family !== 'all') {
          syncColorDotsCollapse(swatchEl, family, true);
          return;
        }
        if (swatchContainer) swatchContainer.classList.add("swatch--expanded");
        dots.forEach((dot) => {
          dot.classList.remove("hidden");
        });
        element.classList.add("hidden");
      });
    });

    elements.colorSwatchLess.forEach((element) => {
      const id = element.dataset.id;
      const dots = document.querySelectorAll(`[data-product-id="${id}"] [data-dot-selector]`);
      const swatchContainer = element.closest(".swatch");
      element.addEventListener("click", function () {
        const swatchEl = element.closest('.swatch');
        const activeBtn = swatchEl && swatchEl.querySelector('.color-families__item[aria-pressed="true"]');
        const family = activeBtn ? ((activeBtn.dataset.colorFamily || 'all').trim() || 'all') : 'all';
        if (swatchEl && swatchEl.querySelector('.color-families') && family !== 'all') {
          syncColorDotsCollapse(swatchEl, family, false);
          return;
        }
        if (swatchContainer) swatchContainer.classList.remove("swatch--expanded");
        dots.forEach((dot) => {
          if (dot.dataset.expand == "true") {
            dot.classList.add("hidden");
          } else {
            dot.classList.remove("hidden");
          }
        });
        element.classList.add("hidden");
      });
    });

    // function disabled to increase performance
    // to switch between products enable and make sure all "image-container" are rendered

    /*
    elements.colorSwatchVariantSelector.forEach((colorSwatch) => {
      colorSwatch.addEventListener("click", function () {
        const productId = colorSwatch.dataset.productSelector;
        const variantId = colorSwatch.dataset.variantSelector;
        const variantImageContainer = document.querySelector(`[data-variant-id="${variantId}"]`);
        const imageContainers = document.querySelectorAll(
          `[data-product-id="${productId}"] .image-container`
        );
        imageContainers.forEach((imageSet) => {
          imageSet.classList.remove("selected");
        });
        variantImageContainer.classList.add("selected");
      });
    });

    */
  }

  document.querySelectorAll('.swatch.js-variant-selector .color-families').forEach((filterList) => {
    const swatchEl = filterList.closest('.swatch');
    if (!swatchEl) return;

    const filterButtons = filterList.querySelectorAll('.color-families__item[data-color-family]');

    filterList.addEventListener('click', (event) => {
      const button = event.target.closest('.color-families__item');
      if (!button) return;

      const selectedFamily = (button.dataset.colorFamily || '').trim();

      filterButtons.forEach((btn) => {
        const isActive = btn === button;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      syncColorDotsCollapse(swatchEl, selectedFamily, false);
    });

    const scrollWrapper = filterList.closest('.swatch__color-families-scroll');
    if (scrollWrapper) {
      const updateScrollFades = () => {
        const maxScroll = filterList.scrollWidth - filterList.clientWidth;
        scrollWrapper.classList.toggle('can-scroll-left', filterList.scrollLeft > 1);
        scrollWrapper.classList.toggle('can-scroll-right', maxScroll - filterList.scrollLeft > 1);
      };
      updateScrollFades();
      filterList.addEventListener('scroll', updateScrollFades, { passive: true });
      window.addEventListener('resize', updateScrollFades, { passive: true });
    }
  });

  // Before after drag

  if (typeof elements.beforeAfterResize !== "undefined" && elements.beforeAfterResize !== null) {
    const element = elements.beforeAfterResize;
    const handle = elements.beforeAfterHandle;
    const wrapper = elements.beforeAfterWrapper;

    handle.addEventListener("pointerdown", (e) => {
      handle.setPointerCapture(e.pointerId);

      if (typeof elements.readmoreButtons !== "undefined" && elements.readmoreButtons !== null) {
        elements.readmoreButtons.forEach((button) => {
          let id = button.dataset.blockId;
          let parent = document.querySelector(`.c-accordion__panel--${id} .expand-item`);
          button.addEventListener("click", () => {
            button.parentElement.classList.add("expand");
            button.style.display = "none";
          });
        });
        handle.addEventListener("pointermove", resize);
        handle.addEventListener(
          "pointerup",
          () => {
            handle.removeEventListener("pointermove", resize);
          },
          { once: true }
        );
      }
    });

    function resize(e) {
      let pageWidth = elements.beforeAfterContainer.offsetWidth;
      let propWidth = (e.pageX / pageWidth) * wrapper.offsetWidth;
      let widthValue = `${(100 / wrapper.offsetWidth) * propWidth}%`;
      element.style.width = widthValue;
      handle.style.left = widthValue;
    }
  }

  if (typeof elements.readmoreButtons !== "undefined" && elements.readmoreButtons !== null) {
    elements.readmoreButtons.forEach((button) => {
      let id = button.dataset.blockId;
      let parent = document.querySelector(`.c-accordion__panel--${id} .expand-item`);
      button.addEventListener("click", () => {
        button.parentElement.classList.add("expand");
        button.style.display = "none";
      });
    });
  }

  if (elements.mobileSearchIcon) {
    window.addEventListener("scroll", function () {
      if (window.scrollY >= 30) {
        elements.mobileSearchIcon.classList.add('sticky--active');
        elements.searchForm.classList.add('sticky--active');
      } else {
        elements.mobileSearchIcon.classList.remove('sticky--active');
        elements.searchForm.classList.remove('sticky--active');
      }
    });
  }
});

document.querySelector(".mobile-menu__cart-icon")?.addEventListener("click", () => {
  Rebuy.SmartCart.show();
});
document.querySelectorAll(".btn.js-ajax-submit").forEach((item) =>
  item.addEventListener("click", (event) => {
    event.preventDefault();
    Rebuy.SmartCart.show();
  })
);

/* Back to Top Button */
const backToTopButton = document.querySelector("#back-to-top");

if (backToTopButton) {
  window.addEventListener("scroll", function () {
    if (window.scrollY > window.innerHeight) {
      backToTopButton.style.display = "block";
    } else {
      backToTopButton.style.display = "none";
    }
  });

  backToTopButton.addEventListener("click", (event) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });
}

// Hero Banner Video
const imageElement = document.getElementById("hero-banner-image");
const iframeElement = document.querySelector(".home-header-video__wrapper");
const iframe = document.querySelector(".home-header-video__wrapper iframe");
const closeButton = document.querySelector(".close-button");

if (iframeElement) {
  imageElement.addEventListener("click", function () {
    iframeElement.style.top = "0";
    animateSlideDown();
    setTimeout(function () {
      closeButton.style.display = "block";
    }, 600);
  });
}

closeButton.addEventListener("click", function () {
  animateSlideUp();
  closeButton.style.display = "none";
});

function animateSlideDown() {
  const animationDuration = 1200;
  const fps = 60;
  const startPosition = -125;
  const endPosition = 0;
  const frameIncrement = (endPosition - startPosition) / (animationDuration / (1000 / fps));

  if (iframe && iframe.dataset.src) {
    iframe.src = iframe.dataset.src;
  }

  let currentPosition = startPosition;

  const animate = () => {
    currentPosition += frameIncrement;
    iframeElement.style.top = currentPosition + "vh";

    if (currentPosition < endPosition) {
      requestAnimationFrame(animate);
    } else {
      iframeElement.style.top = endPosition + "vh";
    }
  };

  animate();
  playVideo();
}

function animateSlideUp() {
  const animationDuration = 500;
  const fps = 60;

  const startPosition = 0;
  const endPosition = -125;
  const frameIncrement = (endPosition - startPosition) / (animationDuration / (1000 / fps));

  let currentPosition = startPosition;

  const animate = () => {
    currentPosition += frameIncrement;
    iframeElement.style.top = currentPosition + "vh";

    if (currentPosition > endPosition) {
      requestAnimationFrame(animate);
    } else {
      iframeElement.style.top = endPosition + "vh";
    }
  };

  animate();
  pauseVideo();
}

let player;

function onYouTubePlayerAPIReady() {
  player = new YT.Player("player", {
    events: {
      onReady: onPlayerReady,
    },
  });
}

function onPlayerReady(event) {
  event.target.console.log("ready");
}

function playVideo() {
  if (player) {
    player.playVideo();
    console.log("playing");
  }
}

function pauseVideo() {
  if (player) {
    player.pauseVideo();
    console.log("paused");
  }
  iframe.dataset.src = iframe.src;
  iframe.src = "";
}
